import { action, observable } from 'mobx'

import Ds from './ds'
import Datehelper from '../utils/datehelper';

class Activities {
  @observable data = []

  @observable ds = new Ds()

  @action loadAllActivityByDateRange(startDate, endDate, callback) {
    var convertedStartDate = new Date(Date.parse(startDate))
    var formattedStartDate = Datehelper.dateToTimestamp(convertedStartDate)
    
    var convertedEndDate = new Date(Date.parse(endDate))
    convertedEndDate.setDate(convertedEndDate.getDate()+1)
    var formattedEndDate = Datehelper.dateToTimestamp(convertedEndDate)

    let query = `{ activities( start: "${ formattedStartDate }" end: "${ formattedEndDate }" hash: "${ localStorage.getItem('userHash') }") { id userId user { firstName lastName } activity activitySectionTypeId activitySectionType { name url } activitySectionId activitySectionId entityId entityTypeId entityType { name url } createdAt } }`

    console.log(query)

    this.ds.query(query, (data) => {
      if ( data.activities.length > 0 ) {
        this.data = data.activities.map((activity) => {    
          activity.activitySectionTypeName = ( activity.activitySectionType.name.length > 0 ? activity.activitySectionType.name : '' )
          activity.activitySectionTypeUrl = ( activity.activitySectionType.url.length > 0 ? activity.activitySectionType.url : '' )
          activity.entityTypeName = ( activity.entityType.name.length > 0 ? activity.entityType.name : '' )
          activity.entityTypeUrl = ( activity.entityType.url.length > 0 ? activity.entityType.url : '' )
          activity.userName = ( activity.user.firstName.length > 0 ? activity.user.firstName + ' ' + activity.user.lastName : '' )

          return activity
        })

        if (callback) {
          callback(this.data)
        }
      }
    })
  }

  @action resetActivityDate() {
    this.data = []
  }

  @action logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId, callback) {
    let query = `mutation {
      addActivity(
        userId: ${ userId },
        activity: "${ activity }",
        activitySectionTypeId: ${ activitySectionTypeId },
        activitySectionId: ${ activitySectionId },
        entityId: ${ entityId },
        entityTypeId: ${ entityTypeId },
        hash: "${ localStorage.getItem('userHash') }"
      ) { id } }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
          callback()
      }
    })
  }
}

export default new Activities()



// WEBPACK FOOTER //
// ./src/stores/activities.js